import React from "react";

import classNames from "classnames";
import { Field } from "formik";
import { FormattedMessage } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";

import { ReactComponent as IconError18 } from "../../../icons/icon/18/a-icon-error-18.svg";
import SimpleRichText from "../../../templates/text/simpleRichText";

import "./checkbox.scss";

const Checkbox = ({
  className = "",
  data = null,
  errors,
  id,
  label = "No label supplied",
  onBlur,
  onChange,
  required = false,
  small = false,
  touched,
  value = false,
}) => (
  <Field
    name={id}
  >
    {() => (
      <Form.Group
        className={classNames(
          "checkbox-form",
          className,
          {
            "checkbox-small": small,
            required,
          },
        )}
      >
        <Form.Check
          id={id}
          name={id}
          type="checkbox"
          onChange={onChange}
          onBlur={onBlur}
          className={classNames("mr-9",
            { "is-invalid": errors[id] && touched[id] },
            { "mb-0": !required || (errors[id] && touched[id]) })}
          isInvalid={errors[id] && touched[id]}
          label={data ? <SimpleRichText data={data} openLinksInNewTab /> : label}
          value={value}
        />
        <Form.Text
          className={classNames({ "invalid-feedback": errors[id] && touched[id] })}
        >
          {errors[id] && touched[id]
            ? <div><IconError18 />{errors[id]}</div>
            : <>{!required && <FormattedMessage id="form.optional" />}</>}
        </Form.Text>
      </Form.Group>
    )}
  </Field>
);

Checkbox.propTypes = {
  className: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.object]),
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]),
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  small: PropTypes.bool,
  touched: PropTypes.oneOfType([PropTypes.object]).isRequired,
  value: PropTypes.bool,
};

export default Checkbox;
